import * as React from 'react'
import { useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { BlockedPeriodPolicyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import DeleteBlockedPeriodModal from 'modules/timeoff/components/BlockedPeriodsSettings/Modals/DeleteBlockedPeriodModal'
import AccessGroupStrategies from 'modules/timeoff/lib/BlockedPeriods/AccessGroupStrategies'

interface Props {
  policy: BlockedPeriodPolicyFragment
  policies: BlockedPeriodPolicyFragment[]
}

interface IPopover {
  policy: BlockedPeriodPolicyFragment
  setDeletePolicy: React.Dispatch<React.SetStateAction<boolean>>
}

const Popover = ({ policy, setDeletePolicy }: IPopover) => {
  const { navigation } = useNavigation()

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center">
        <PopoverMenu.RouterOption
          title={i18n.t('settings.timeoff_blocked_periods.actions.edit')}
          to={{
            pathname: navigation.settings.timeoffPolicies.blockedPeriodsId.fullPath({
              id: policy.id,
            }),
          }}
        />
        <PopoverMenu.TouchableOption
          title={i18n.t('settings.timeoff_blocked_periods.actions.delete')}
          danger
          onClick={() => setDeletePolicy(true)}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

const Item = ({ policy, policies }: Props) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const subtitle = () => {
    switch (policy.strategy) {
      case AccessGroupStrategies.everyone:
        return i18n.t('settings.timeoff_blocked_periods.fields.access_group_strategy.everyone')
      case AccessGroupStrategies.fqlMultiselect:
        return i18n.t('settings.timeoff_blocked_periods.fields.access_group_strategy.fql')
      case AccessGroupStrategies.members:
        return i18n.t('settings.timeoff_blocked_periods.fields.access_group_strategy.members', {
          number: policy.membersAsAccesses.length,
        })
    }
  }

  return (
    <Box
      flexDirection="row"
      padding="s16"
      justifyContent="spaceBetween"
      width="full"
      alignItems="center"
    >
      <Box flexDirection="row" gap="s16" alignItems="center">
        <Box minWidth="none">
          <Box width="s240">
            <Text.Normal size="300" weight="medium" color="grey1000">
              {policy.name}
            </Text.Normal>
          </Box>
          <Box>
            <Text.Normal size="200" color="grey800">
              {subtitle()}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
      <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
        <Popover policy={policy} setDeletePolicy={setDeleteModalOpen} />
      </Box>
      {deleteModalOpen && (
        <DeleteBlockedPeriodModal
          policyId={policy.id}
          onClose={() => setDeleteModalOpen(false)}
          policies={policies}
        />
      )}
    </Box>
  )
}

export default observer(Item)
